<script setup></script>
<template>
    <div class="tw-py-20 md:tw-pb-48 md:tw-pt-36 container container--narrow">
        <div class="form-panel wysiwyg-output">
            <h2 class="tw-text-center">Digital Declaration Form</h2>
            <h3 class="">Starting your form</h3>
            <p>
                This form is to be completed by or in the presence of the person who is applying for
                insurance cover.
            </p>
            <p>
                Please review all authorities and consents and complete the declarations in order to
                submit your form to Lifebroker.
            </p>
            <p>
                This form should be completed in full as the commencement of your application may be
                delayed if the information provided is incomplete.
            </p>
            <button class="btn btn--green tw-mt-10 btn--full" @click="$emit('advance-step')">
                Next
            </button>
        </div>
    </div>
</template>
